<div class="row">
  <div class="col mr-2">
    <select
      
      (change)="assignTemplateRole()"
      style="font-size: 13px; font-weight: 100"
      class="form-control"
      id="exampleFormControlSelect1"
      [(ngModel)]="roleToAssign"
    >
      <option [value]="'none'">
        {{ "assigntemplateroles.choose" | trans }}
      </option>
      <option
        [selected]="role.assignedperson === personId"
        *ngFor="let role of roleList"
        value="{{ role.roleId }}"
        [disabled]="role.assignedperson"
      >
        {{ role.projectrole }}
        <span *ngIf="role.assignedperson"
          >{{ "assigntemplateroles.assignedto" | trans
          }} <app-personname
            [chatType]="true"
            [creatorstage]="''"
            [enableChange]="false"
            [personId]="role.assignedperson"
          ></app-personname
        ></span>
      </option>
    </select>
  </div>
</div>
